// extracted by mini-css-extract-plugin
export default {"header":"Dropdown__header--eTikt","image":"Dropdown__image--OlEZ_","body":"Dropdown__body--w80IM"};